<script>
/* eslint no-console: 0 */
import { useAlert } from 'dashboard/composables';
import QrCode from 'shared/components/QrCode.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    QrCode,
    useAlert,
  },
  props: {
    id: { type: Number, default: null },
    edname: { type: String, default: '' },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      getWhatsappQRCode: {
        useAlert: false,
        showLoading: false,
      },
      name: this.edname,
      show: true,
      qrData: '',
      intervalId: null,
    };
  },
  computed: {
    pageTitle() {
      return `Scan QR Code - ${this.edname}`;
    },
    ...mapGetters({
      getBase64QRCode: 'whatsappAccounts/getBase64QRCode',
    }),
  },
  mounted() {
    this.getWhatsappAccountQRcode();
  },
  methods: {
    getWhatsappAccountQRcode() {
      // Show loading on button
      this.getWhatsappQRCode.showLoading = true;
      // Make API Calls
      this.$store
        .dispatch('whatsappAccounts/getWhatsappAccountQRCode', this.id)
        .then(() => {
          this.getWhatsappQRCode.showLoading = false;
          this.intervalId = setInterval(this.pollAccountStatus, 5000);
        })
        .catch(error => {
          this.getWhatsappQRCode.showLoading = false;
          const errorMessage =
            error?.message ||
            this.$t(
              'WHATSAPP_PERSONAL_ACCOUNT.ACCOUNTS.EDIT.API.ERROR_MESSAGE'
            );
          useAlert(errorMessage);
          setTimeout(() => {
            this.onClose();
          }, 10);
        });
    },
    pollAccountStatus() {
      this.$store
        .dispatch('whatsappAccounts/getWhatsappAccountStatus', this.id)
        .then(logged_in => {
          if (logged_in) {
            useAlert('WhatsApp account connected successfully');
            this.onClose();
            clearInterval(this.intervalId);
          }
        })
        .catch(error => {
          console.log('Error polling account status:', error);
          clearInterval(this.intervalId);
        });
    },
    clear() {
      clearInterval(this.intervalId);
    },
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    clearInterval(this.intervalId);
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header :header-title="pageTitle" />
    <div class="w-full">
      <div class="container main-div">
        <div class="content-wrapper">
          <div class="instructions">
            <ol class="steps">
              <li class="step-item">Open WhatsApp on your phone</li>
              <li class="step-item">
                Go to settings by tapping on your profile photo,Menu
                <fluent-icon class="wa-icon" icon="whatsapp-menus" />
                , or Settings
                <fluent-icon class="wa-icon" icon="whatsapp-setting" />
              </li>
              <li class="step-item">
                Tap Linked devices and then Link a device
              </li>
              <li class="step-item">
                Point your phone to this screen to capture the QR code
              </li>
            </ol>
          </div>
          <div class="qr-code">
            <div class="image-wrapper" data-ref="">
              <div class="image-overlay">
                <span class="image-overlay-icon" />
              </div>
            </div>
            <woot-loading-state v-if="this.getWhatsappQRCode.showLoading" />
            <qr-code
              v-if="!this.getWhatsappQRCode.showLoading"
              :data="getBase64QRCode"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
::v-deep {
  .ProseMirror-menubar {
    @apply hidden;
  }

  .ProseMirror-woot-style {
    @apply min-h-[12.5rem];

    p {
      @apply text-base;
    }
  }
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px;
  box-sizing: border-box;
}

.main-div {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.content-wrapper {
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: space-between;
}

.instructions {
  width: 60%;
  margin-right: 5%;
}

.title {
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: bold;
}

.btn-link {
  cursor: pointer;
  color: #007bff;
  text-decoration: none;
}

.link-text {
  margin: 10px 0;
}

.divider {
  height: 1px;
  background-color: #ddd;
  margin: 10px 0;
}

.steps {
  padding-left: 20px;
  list-style-type: decimal;
}

.step-item {
  margin-bottom: 10px;
  font-size: 0.875rem;
  line-height: 40px;
  color: #3b4a54;
}

.qr-code {
  width: 40%;
}

.image-wrapper {
  position: relative;
  width: 100%;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wa-icon {
  display: inline-block;
}
</style>
